<template>
  <div>
    <v-select
        v-if="showStatusFilter"
        v-model="currentStatus"
        hide-details
        label="Выберите статус покупок"
        item-value="id"
        item-text="title"
        :items="statusesArr"
    >
      <template v-slot:prepend>
        <v-icon :color="statuses[currentStatus].color">{{ statuses[currentStatus].icon }}</v-icon>
      </template>

      <template v-slot:item="{item}">
        <v-icon
            left
            :color="item.color"
        >
          {{item.icon}}
        </v-icon>
        {{item.title}}
      </template>
    </v-select>

    <Paginator
        :empty-info="archived ? 'Вы не скрыли ни одной закупки' : 'Закупки появятся автоматически, когда Вам будет выставлен первый счёт'"
        :data="buyouts"
        :endpoint="endpoint"
        :transformParams="transformParams"
        @setAskFn="setAskFn"
        @load="onLoad"
    >
      <template>
        <v-list :dense="$vuetify.breakpoint.mobile">
          <v-list-item
              v-if="showStoreLink"
              two-line
              @click="openStore"
          >
            <v-list-item-avatar>
              <v-icon
                  color="white"
                  class="accent"
              >
                mdi-cart-plus
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Сделать заказ</v-list-item-title>
              <v-list-item-subtitle>Перейти в магазин и участвовать в закупке</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <BuyoutListItem
              v-for="buyout in buyouts"
              :key="buyout.id"
              :item="buyout"
          ></BuyoutListItem>
        </v-list>
      </template>
    </Paginator>
  </div>
</template>

<script>

import {status} from '@/constants'
import BuyoutListItem from '@/components/BuyoutListItem'
import Paginator from '@/components/Paginator'
import {getSourceId, getStoreUrl} from '@/composables/context'
import {windowOpen} from '@/services/vkApi'

const paymentStatusStoredKey = 'filter.payment.status'
let _currentRqId

export default {
  name: 'BuyoutList',
  components: {BuyoutListItem, Paginator},
  computed: {
    showStatusFilter: function () {
      return !this.archived
    },
    showStoreLink: function () {
      return !this.archived && !!this.storeUrl
    },
    storeUrl: getStoreUrl
  },
  data () {
    return {
      askFn: function () {},
      buyouts: [],
      currentStatus: this.$localStorage.get(paymentStatusStoredKey, status.payment.all.id),
      endpoint: this.$API.BUYOUTS.LIST,
      statuses: status.payment,
      statusesArr: Object.values(status.payment)
    }
  },
  methods: {
    onLoad: function (data) {
      if (_currentRqId === +data.rqId) {
        this.buyouts = this.buyouts.concat(data.items)
      }
    },
    openStore: function () {
      windowOpen(this.storeUrl)
    },
    reaskData: function () {
      this.buyouts = []
      this.askFn()
    },
    setAskFn: function (askFn) {
      this.askFn = askFn
    },
    transformParams: function (params) {
      _currentRqId = new Date().getTime()
      let opt = {
        rqId: _currentRqId,
        archived: this.archived,
        sourceId: getSourceId(),
        limit: params.limit,
        offset: params.offset
      }
      if (!this.archive) opt.paymentStatus = this.currentStatus

      return opt
    }
  },
  props: {
    archived: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    archived: function () {
      this.reaskData()
    },
    currentStatus: function (val) {
      this.$localStorage.set(paymentStatusStoredKey, val)
      this.reaskData()
    }
  }
}
</script>

<style scoped>

</style>